import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=6b61a6bb&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61a6bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b61a6bb')) {
      api.createRecord('6b61a6bb', component.options)
    } else {
      api.reload('6b61a6bb', component.options)
    }
    module.hot.accept("./Forgot.vue?vue&type=template&id=6b61a6bb&scoped=true&", function () {
      api.rerender('6b61a6bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/Forgot.vue"
export default component.exports